<template>
  <tr>
    <td class="plaintext-sm">{{ hi3PastYear.yearOfService }}</td>
    <td class="plaintext-sm">{{ hi3PastYear.age }}</td>
    <td class="plaintext-sm">{{ hi3PastYear.calendarYear }}</td>
    <td>
      <div class="form-group">
        <select class="form-control input-sm"
                :value="hi3PastYear.yearOfServiceRank" @change="onRankChange($event.target.value)">
          <option v-for="rank in hi3PastYear.overrideRanks" :key="rank" :value="rank">{{ rank }}</option>
        </select>
      </div>
    </td>
  </tr>
</template>

<script>
export default {
  props: {
    hi3PastYear: Object,
  },

  methods: {
    onRankChange(rank) {
      const hi3PastYear = {
        ...this.hi3PastYear,
        yearOfServiceRank: rank,
      };
      this.$emit('change', hi3PastYear);
    },
  },
};
</script>

<style lang="scss" scoped>
input, select {
  width: 60px;
}

td {
  text-align: center;
}
</style>
